import XLoaderWithoutStyle from "../common/XLoaderWithoutStyle";
import XModal from "../common/XModal";
import usePartnerCaseImport from "../../hooks/usePartnerCaseImport";

const messageClasses = "mb-2";
const summaryBoxClasses = "p-4 rounded bg-surface-alt";
const summaryHeaderClasses = "flex justify-between";
const caseNameClasses = "font-semibold";
const dateClasses = "text-body text-sm";
const subTextClasses = "text-body mt-1";

const IntegratorModal = ({ selectedCase, selectedPartner, isAutoImporting = false, onClose, onImported, caseId }) => {
    const { isCaseImporting, startImport } = usePartnerCaseImport({ selectedCase, selectedPartner, isAutoImporting, onClose, onImported, caseId });

    return (
        <XModal
            isOpen={!!selectedCase}
            title="Import Confirmation"
            onClose={onClose}
            onSubmit={isAutoImporting ? undefined : startImport}
            submitText="Import"
            isSubmitting={isCaseImporting}
            size="lg"
        >
            <div className="text-sm">
                {isAutoImporting ? (
                    <p className={messageClasses}>Case matched by ID. Import is in progress.<br />
                        It may take up to 5 minutes to import.
                    </p>
                ) : (
                    <p className={messageClasses}>Are you sure you want to import this case?<br />
                        It may take up to 5 minutes to import.
                    </p>
                )}

                <div className={summaryBoxClasses}>
                    <div className={summaryHeaderClasses}>
                        <div className={caseNameClasses}>Case {selectedCase?.caseName}</div>
                        <div className={dateClasses}>{selectedCase?.date}</div>
                    </div>
                    <div className={subTextClasses}>{selectedCase?.caseName}</div>
                </div>

                {isCaseImporting && <div className="mt-3"><XLoaderWithoutStyle /></div>}
            </div>
        </XModal>
    );
};

export default IntegratorModal;
